import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 26, 2026">
      <div data-testid="terms-page" className="space-y-8">
        <p className="text-sm text-slate-300 leading-relaxed">
          Welcome to Entrepreneur OS ("ECO", "we", "us", or "our"). These Terms of Service ("Terms") govern your
          access to and use of the ECO platform, website and applications (the "Service"). By creating an account or
          using the Service, you agree to these Terms. If you do not agree, please do not use the Service.
        </p>

        <Section title="1. The Service">
          <p>ECO is an AI-powered business and entrepreneurship education platform. It provides AI mentoring, lessons,
            tools (such as the Deal Analyzer, Decision Lab, Negotiation Simulator and Founder Roadmaps), case studies,
            assessments and gamified challenges, generated in part by third-party AI models.</p>
        </Section>

        <Section title="2. Educational Purpose — Not Professional Advice">
          <p>All content, AI responses, document analyses and tools are provided for <strong>educational and
            informational purposes only</strong>. They do <strong>not</strong> constitute legal, financial, tax,
            investment or professional advice. The Deal Analyzer and similar features are not a substitute for review
            by a qualified attorney or advisor. AI output may be inaccurate, incomplete or out of date — always verify
            important decisions with a licensed professional. You are solely responsible for any decisions you make.</p>
        </Section>

        <Section title="3. Accounts">
          <p>You must provide accurate information and keep your login credentials secure. You are responsible for all
            activity under your account. You must be at least 16 years old (or the age of majority in your jurisdiction)
            to use the Service. You may sign in using email/password or Google.</p>
        </Section>

        <Section title="4. Subscriptions, Billing & Cancellation">
          <p>ECO offers a free tier and a paid "ECO Pro" subscription billed monthly or yearly through our payment
            processor, Stripe. Paid subscriptions renew automatically at the end of each billing period unless
            cancelled. You can <strong>cancel at any time</strong> from your Account page; your Pro access remains
            active until the end of the current paid period, after which it will not renew. Except where required by
            law, payments are non-refundable. Prices may change with prior notice.</p>
        </Section>

        <Section title="5. Acceptable Use">
          <p>You agree not to misuse the Service, including: violating any law; uploading content you have no right to
            share; attempting to reverse-engineer, scrape or disrupt the Service; using it to generate unlawful,
            harmful or infringing material; or reselling the Service without permission.</p>
        </Section>

        <Section title="6. Your Content">
          <p>You retain ownership of content you submit (including documents you upload for analysis). You grant us a
            limited licence to process that content to provide the Service (for example, sending it to our AI provider
            to generate an analysis). Do not upload content you are not permitted to share, or that is highly sensitive.</p>
        </Section>

        <Section title="7. Intellectual Property">
          <p>The Service, including its software, design, branding and original content, is owned by ECO and protected
            by intellectual-property laws. You may use AI-generated output for your own business and learning purposes.</p>
        </Section>

        <Section title="8. Third-Party Services">
          <p>The Service relies on third parties including Stripe (payments), Anthropic (AI processing) and Google
            (optional sign-in). Your use of those features is also subject to those providers' terms.</p>
        </Section>

        <Section title="9. Disclaimers & Limitation of Liability">
          <p>The Service is provided "as is" without warranties of any kind. To the maximum extent permitted by law,
            ECO is not liable for any indirect, incidental or consequential damages, or for any decisions made in
            reliance on the Service. Our total liability for any claim is limited to the amount you paid us in the
            12 months before the claim.</p>
        </Section>

        <Section title="10. Termination">
          <p>You may stop using the Service at any time. We may suspend or terminate accounts that violate these Terms.</p>
        </Section>

        <Section title="11. Changes to These Terms">
          <p>We may update these Terms from time to time. Material changes will be posted here with an updated date.
            Continued use of the Service after changes means you accept the revised Terms.</p>
        </Section>

        <Section title="12. Contact">
          <p>For any questions about these Terms, contact us at{" "}
            <a href="mailto:ecoentrepreneuros@gmail.com" className="text-[#4d8bff] hover:underline">ecoentrepreneuros@gmail.com</a>.</p>
        </Section>
      </div>
    </LegalLayout>
  );
}
